// react library imports
import { useRef, useMemo} from 'react';

// style imports
import "../Input/Input.css";
import './EmailTextField.css';

const EmailTextField = ({id, onChange, initialValue}) => {
    // set state of value
    const inputRef = useRef(null);

    // handle input focus
    const handleEditClick = () => {
        inputRef.current.focus();
    };

    // handle onchange event
    const handleOnChange=(e)=>{
      if (onChange) {
        onChange(e.target.value)
      }
    }
    
    // useMemo to memoize the input value and only refresh when `initialValue` changes
    const memoizedValue = useMemo(() => initialValue, [initialValue]);
  return (
    <div className="form-input">
      <input type="email" placeholder="Email id" id={id}
      value={memoizedValue} onChange={handleOnChange} ref={inputRef}/>
      <label htmlFor={id} onClick={handleEditClick}>Email ID</label>
    </div>
  )
}

export default EmailTextField